import { render, staticRenderFns } from "./medicineList.vue?vue&type=template&id=faf332d4"
import script from "./medicineList.vue?vue&type=script&lang=js"
export * from "./medicineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports